import { render, staticRenderFns } from "./Limbo.vue?vue&type=template&id=312e1c9e&"
import script from "./Limbo.vue?vue&type=script&lang=ts&"
export * from "./Limbo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports